
export default [
  {
    path: '/office',
    component: resolve => require(['@/pages/navigationMenu/office.vue'], resolve),
    name: 'office',
    meta: {
      // keepAlive: true,
      title: '办公',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/systemSetting',
    component: resolve => require(['@/pages/navigationMenu/systemSetting.vue'], resolve),
    name: 'systemSetting',
    meta: {
      // keepAlive: true,
      title: '系统设置',
      scollTopPosition: 0 // 滚动条位置
    }
  },
  {
    path: '/chart',
    component: resolve => require(['@/pages/navigationMenu/chart.vue'], resolve),
    name: 'chart',
    meta: {
      // keepAlive: true,
      title: '图表'
    }
  },
  {
    path: '/configuration',
    component: resolve => require(['@/pages/navigationMenu/configuration.vue'], resolve),
    name: 'configuration',
    meta: {
      // keepAlive: true,
      title: '配置'
    }
  },
  {
    path: '/toDo',
    name: 'toDo',
    component: resolve => require(['@/pages/navigationMenu/toDo.vue'], resolve),
    meta: {
      // keepAlive: true,
      title: '待办'
    }
  },
  {
    path: '/message',
    name: 'message',
    component: resolve => require(['@/pages/navigationMenu/message.vue'], resolve),
    meta: {
      // keepAlive: true,
      title: '消息'
    }
  },
  {
    path: '/orientation',
    name: 'orientation',
    component: resolve => require(['@/pages/navigationMenu/orientation.vue'], resolve),
    meta: {
      // keepAlive: true,
      title: '迎新'
    }
  },
  {
    path: '/downLoad',
    name: 'downLoad',
    component: resolve => require(['@/pages/navigationMenu/downLoad.vue'], resolve),
    meta: {
      // keepAlive: true,
      title: '下载中心'
    }
  },
  {
    path: '/report',
    name: 'report',
    component: resolve => require(['@/pages/navigationMenu/report.vue'], resolve),
    meta: {
      // keepAlive: true,
      title: '汇报'
    }
  },
  {
    path: '/notice',
    name: 'notice',
    component: resolve => require(['@/pages/navigationMenu/notice.vue'], resolve),
    meta: {
      // keepAlive: true,
      title: '群聊'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/main.js